import React, { ReactElement } from 'react';
import { Row } from 'antd';
import image from '../../images/noAssignment.svg';
import Text from '../Text';
import Wrapper from '../Wrapper';
import './NoDataPage.less';

export type NoDataPageProps = {
  title?: string | ReactElement;
  imgPath?: string;
  heightNum?: string;
};

const TNoDataPageProps: React.FC<NoDataPageProps> = ({
  title = '',
  imgPath = '',
  heightNum = '20rem',
}) => {
  return (
    <Row
      className="t-noDataSection"
      style={{ height: `calc(100vh - ${heightNum})` }}
    >
      <div className="t-noData">
        <img src={imgPath ? imgPath : image} draggable="false" />
        <Wrapper pt={2}>
          <Text rows={3} level={2} textColor="dark-50">
            <span className="t-title-style">{title}</span>
          </Text>
        </Wrapper>
      </div>
    </Row>
  );
};

export default TNoDataPageProps;
